import axios from '@/request';
import qs from 'qs';

export default {
  async getCoaches(params: any) {
    return axios.get('coach/list', { params });
  },
  async getTrainees(params: any) {
    return axios.get('trainee/list', { params });
  },
  async list(params: any) {
    return axios.get('train/list', { params });
  },
  async add(params: any) {
    return axios.post('train/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('train/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('train/detail', { params });
  },
  async delete(params: any) {
    return axios.post('train/delete', qs.stringify(params));
  }
};
